/**
 * PayablesPage — Tab wrapper para Cuentas por Pagar con ayuda contextual.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/HelpPanel'
import { HELP } from '@/data/helpContent'

const PAGE_META: Record<string, { title: string; subtitle: string; helpKey: string }> = {
  payments:    { title: 'Pagos a Proveedores', subtitle: 'Registro y confirmación de pagos a proveedores.', helpKey: 'payables.payments' },
  aging:       { title: 'Antigüedad de Saldos', subtitle: 'Análisis de deuda a proveedores por días de mora.', helpKey: 'payables.aging' },
  statements:  { title: 'Estados de Cuenta', subtitle: 'Detalle de facturas y pagos por proveedor.', helpKey: 'payables.statements' },
  schedule:    { title: 'Calendario de Pagos', subtitle: 'Pagos a proveedores programados por fecha de vencimiento.', helpKey: 'payables.schedule' },
  'cash-flow': { title: 'Flujo Proyectado', subtitle: 'Egresos esperados por semana según vencimientos.', helpKey: 'payables.cash-flow' },
}

export default function PayablesPage() {
  const { pathname } = useLocation()
  const segment = pathname.split('/').pop() || 'payments'
  const meta = PAGE_META[segment] || PAGE_META.payments

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <PageHeader title={meta.title} subtitle={meta.subtitle} help={HELP[meta.helpKey]} />
      <Outlet />
    </div>
  )
}
